(function () {
  if (!window || !window.localStorage) return;

  const STORAGE_KEY = 'shop_recently_viewed_v1';
  const MAX_ITEMS = 4;
  const containerSelector = '[data-recently-viewed]';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function pushProduct(product) {
    if (!product || !product.handle) return;

    let list = getList();

    list = list.filter((item) => item.handle !== product.handle);
    list.unshift(product);

    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);

    saveList(list);
  }

  function render() {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const list = getList();
    if (!list.length) {
      container.innerHTML = '';
      return;
    }

    const html = list
      .map((item) => {

        /* Robust compare-at-price detection:
           - strip non-number chars
           - parse float
           - valid only if numeric and > 0
        */

        let rawCompare = item.compare_at_price || "";
        rawCompare = rawCompare.toString().trim();

        // Try to extract a numeric value (remove currency symbols, commas, whitespace, other chars)
        const numericString = rawCompare.replace(/[^\d.]/g, "");
        const numericValue = numericString === "" ? NaN : parseFloat(numericString);

        const compareValid = Number.isFinite(numericValue) && numericValue > 0;

        // debug (uncomment if you need console info)
        // console.log('compare debug ->', { rawCompare, numericString, numericValue, compareValid });

        return `
          <div class="rv-card">
            <div class="rv-img-wrap">
              <a href="${item.url}">
                <img src="${item.image}" alt="${item.title}" loading="lazy">
              </a>

              <div class="rv-add-bar" data-handle="${item.handle}">
                Add to cart
              </div>
            </div>

            <div class="rv-info">
              <a class="rv-title" style="color:#000;" href="${item.url}">
                ${item.title}
              </a>

              <div class="rv-sizes">
                <span class="rv-size">S</span>
                <span class="rv-size">M</span>
                <span class="rv-size">L</span>
                <span class="rv-size">XL</span>
                <span class="rv-size">XXL</span>
              </div>

              <div class="rv-price-wrap">
                <span class="rv-price">${item.price}</span>

                ${
                  compareValid
                    ? `<span class="rv-compare">${rawCompare}</span>`
                    : ""
                }
              </div>
            </div>
          </div>
        `;
      })
      .join('');

    container.innerHTML = `<div class="rv-grid">${html}</div>`;

    /* SIZE SELECT */
    container.querySelectorAll('.rv-sizes').forEach((wrap) => {
      wrap.addEventListener('click', (e) => {
        if (!e.target.classList.contains('rv-size')) return;

        wrap.querySelectorAll('.rv-size').forEach((s) => s.classList.remove('active'));
        e.target.classList.add('active');
      });
    });

    /* ADD TO CART */
    container.querySelectorAll('.rv-add-bar').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const card = btn.closest('.rv-card');
        const activeSize = card.querySelector('.rv-size.active');

        if (!activeSize) {
          alert("Please select a size before adding to cart.");
          return;
        }

        const handle = btn.getAttribute("data-handle");
        const selectedSize = activeSize.textContent.trim();

        try {
          const res = await fetch(`/products/${handle}.js`);
          const product = await res.json();

          const normalize = (s) => (s || "").toLowerCase().replace(/\s+/g, "");

          const selectedNorm = normalize(selectedSize);

          const alias = {
            s: ["s", "small"],
            m: ["m", "medium"],
            l: ["l", "large"],
            xl: ["xl", "extralarge"],
            xxl: ["xxl", "2xl", "extraextralarge"],
          };

          const matchSet = new Set(alias[selectedNorm] || [selectedNorm]);

          const variant = product.variants.find((v) =>
            matchSet.has(normalize(v.option1))
          );

          if (!variant) {
            alert(`Size ${selectedSize} not available.`);
            return;
          }

          const add = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 }),
          });

          if (!add.ok) throw new Error("Add failed");

          btn.textContent = "Added ✔";
          setTimeout(() => (btn.textContent = "Add to cart"), 2000);
        } catch (err) {
          console.error(err);
          alert("Unable to add item to cart.");
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const product = window.__RECENTLY_VIEWED_PRODUCT;
    if (product && product.handle) pushProduct(product);

    render();

    window.addEventListener('storage', (e) => {
      if (e.key === STORAGE_KEY) render();
    });
  });

  window.RecentlyViewed = { render, push: pushProduct, getList };
})();
